import { useMemo, useCallback } from 'react'
import { favoritesAPI } from '../../services/api'
import { toast } from '../../services/toastService'

/**
 * useEntityNotifyOnSpot - Derives the notify-on-spot state for the current entity
 * from the favorites list, and provides a toggle handler.
 * @atomic @idempotent
 */
export function useEntityNotifyOnSpot({ entityId, favorites, updateFavoriteNotify, t }) {
  const entityNotifyOnSpot = useMemo(() => {
    if (!entityId || !favorites?.length) return false
    const fav = favorites.find(f => (f.entityId || f.entity?.id) === entityId)
    return !!(fav?.notifyOnSpot || fav?.notify_on_spot)
  }, [favorites, entityId])

  const handleEntityNotifyToggle = useCallback(async () => {
    try {
      await favoritesAPI.toggleNotify(entityId)
      updateFavoriteNotify(entityId, !entityNotifyOnSpot)
    } catch {
      toast.error(t('toast.error.generic', 'Something went wrong'))
    }
  }, [entityId, entityNotifyOnSpot, updateFavoriteNotify, t])

  return { entityNotifyOnSpot, handleEntityNotifyToggle }
}
